import { GymnastFriend } from '../types';

export const INITIAL_GYMNAST_FRIENDS: GymnastFriend[] = [
  {
    id: 'friend-backbend',
    name: 'Erika',
    title: 'The Backbend Star ⭐',
    favoriteMove: 'Backbend',
    favoriteColor: '#40E0D0', // turquoise
    accentClass: 'bg-teal-100 text-teal-800 border-teal-300',
    badgeEmoji: '💎',
    tagline: 'Arch like a sparkling turquoise rainbow, Emma!',
    cheers: [
      'Arch like a sparkling turquoise rainbow, Emma! 🌈✨',
      'You are getting stronger and more flexible every day! 💪⭐',
      'Look at those strong arms! Push the sky away! 🚀',
      'Breathe in, smile, and reach for the stars! ✨',
      'High five, teammate! That was super smooth! ✋🎉',
      'Your back is bendy like a gymnastics ribbon! 🎀',
      'Keep your eyes on your hands — you\'ve got this, Emma! 👀',
      'Point those toes and shine bright like a turquoise diamond! 💎',
      'You are practicing like a true gymnastics champion! 🏆',
      'Woohoo! That was amazing, Emma! Let\'s do another one! 🥳'
    ]
  },
  {
    id: 'friend-cartwheel',
    name: 'Chloe',
    title: 'The Cartwheel Queen 🌀',
    favoriteMove: 'Cartwheel',
    favoriteColor: '#00BFFF',
    accentClass: 'bg-blue-100 text-blue-700 border-blue-300',
    badgeEmoji: '⚡',
    tagline: 'Hand, hand, foot, foot — spin like a windmill!',
    cheers: [
      'Whoosh! That was so speedy and clean!',
      'Keep your toes pointed and land softly!',
      'You are a cartwheel superstar!'
    ]
  },
  {
    id: 'friend-handstand',
    name: 'Zara',
    title: 'The Handstand Champ 🤸‍♀️',
    favoriteMove: 'Handstand',
    favoriteColor: '#9370DB',
    accentClass: 'bg-purple-100 text-purple-700 border-purple-300',
    badgeEmoji: '👑',
    tagline: 'Strong arms, tight core, upside-down power!',
    cheers: [
      'Hold it strong! Squeeze those muscles!',
      'Balance is your superpower!',
      'Upside-down looks great on you!'
    ]
  },
  {
    id: 'friend-splits',
    name: 'Ruby',
    title: 'The Splits Master 💖',
    favoriteMove: 'Splits',
    favoriteColor: '#FF7F50',
    accentClass: 'bg-orange-100 text-orange-700 border-orange-300',
    badgeEmoji: '✨',
    tagline: 'Gentle stretching every day brings you closer to the floor!',
    cheers: [
      'Incredible stretch! Remember to breathe out slowly!',
      'Every stretch makes you stronger and more bendy!',
      'So graceful and focused!'
    ]
  },
  {
    id: 'friend-aerial',
    name: 'Lily',
    title: 'The Aerial Wizard 🧚‍♀️',
    favoriteMove: 'Aerial',
    favoriteColor: '#98FB98',
    accentClass: 'bg-emerald-100 text-emerald-700 border-emerald-300',
    badgeEmoji: '🦄',
    tagline: 'No hands, all power, flying through the air!',
    cheers: [
      'You have wings! What amazing flight!',
      'Pure magic in the air!',
      'That looked effortless!'
    ]
  }
];
